window.addEventListener('DOMContentLoaded', () => {
	setDeliveryDate();
});

/**
 * Function for set estimated delivery date in products pages
 * @author rgranados
 * @returns {HTMLElement} data delivery date HTML
 */
function setDeliveryDate () {
  const date = new Date();
  const weekDay = date.getDay();
  const hours = date.getHours();
  const isWeekend = weekDay == 0 || weekDay == 6;

  let daysToAdd = 2;
  let nextDay = new Date(date);

  if (isWeekend || hours > 12) {
    daysToAdd += 1;
  }

  nextDay.setDate(date.getDate() + daysToAdd);
  
  // Check if the estimated delivery date falls on a Sunday and move it to the following Monday
  if (nextDay.getDay() === 0) {
    nextDay.setDate(nextDay.getDate() + 1);
  }

  this.setNextDate(nextDay);
}

/**
 * Function for set next monday
 * @author rgranados
 * @param {Date} nextDay next date obj
 * @returns {HTMLElement}
 */
function setNextDate(nextDay) {
	const nextDayString = nextDay.toLocaleString("de", { weekday: "long" });
	const nextDateString = nextDay.toLocaleString("de", {
		weekday: "long",
		day: "numeric",
		month: "long",
	});
	if (
		nextDayString == "samstag" ||
		nextDayString == "sonntag"
	) {
		const nextMonday = new Date();
		nextMonday.setDate(
			nextMonday.getDate() + ((1 + 7 - nextMonday.getDay()) % 7)
		);
		const nextMondayString = nextMonday.toLocaleString("de", {
			weekday: "long",
			day: "numeric",
			month: "long",
		});
		document.querySelector(".day-delivery").textContent = nextMondayString ;
	} else {
		document.querySelector(".day-delivery").textContent =  nextDateString ;
	}
}